<template>
  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <!-- Brand Logo -->
    <router-link to="/" class="brand-link">
      <img src="@/assets/img/AdminLTELogo.png" alt="AdminLTE Logo" class="brand-image img-circle elevation-3"
           style="opacity: .8">
      <span class="brand-text font-weight-light">Auto Gate System</span>
    </router-link>

    <!-- Sidebar -->
    <div class="sidebar">

      <div class="user-panel mt-3 pb-3 mb-3 d-flex">
        <div class="info justify-content-center">
          <a href="#" class="d-block">{{ $store.state.user.user.username }}</a>
        </div>
      </div>
      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          <!-- Add icons to the links using the .nav-icon class
               with font-awesome or any other icon font library -->
          <li class="nav-item" v-if=can(menu.dashboard)>
            <router-link :to="{name: 'Dashboard'}" class="nav-link" active-class="active" exact>
              <i class="nav-icon fas fa-tachometer-alt"></i>
              <p>
                Dashboard
              </p>
            </router-link>
          </li>
          <li class="nav-item" v-if=can(menu.members)>
            <router-link :to="{name: 'Members'}" class="nav-link" active-class="active">
              <i class="nav-icon fas fa-building"></i>
              <p>
                Members
              </p>
            </router-link>
          </li>
          <li class="nav-item" v-if=can(menu.users)>
            <router-link :to="{name: 'User'}" class="nav-link" active-class="active">
              <i class="nav-icon fas fa-users"></i>
              <p>
                Users
              </p>
            </router-link>
          </li>
          <li class="nav-item" v-if=can(menu.events)>
            <router-link :to="{name: 'Events'}" class="nav-link" active-class="active">
              <i class="nav-icon fas fa-torii-gate"></i>
              <p>
                Events
              </p>
            </router-link>
          </li>
          <li class="nav-item" v-if=can(menu.bsims)>
            <router-link :to="{name: 'BSIMS'}" class="nav-link" active-class="active">
              <i class="nav-icon fas fa-receipt"></i>
              <p>
                BSIMS
              </p>
            </router-link>
          </li>
          <li class="nav-item" v-if=can(menu.permits)>
            <router-link :to="{name: 'Permits'}" class="nav-link" active-class="active">
              <i class="nav-icon fas fa-id-card-alt"></i>
              <p>
                Permits
              </p>
            </router-link>
          </li>
          <li class="nav-item" v-if=can(menu.vehicles)>
            <router-link :to="{name: 'Vehicles'}" class="nav-link" active-class="active">
              <i class="nav-icon fas fa-truck"></i>
              <p>
                Vehicles
              </p>
            </router-link>
          </li>
          <li class="nav-item" v-if=can(menu.retry)>
            <router-link :to="{name: 'Retry'}" class="nav-link" active-class="active">
              <i class="fa fa-cog fa-lg"></i>&nbsp;
              <p>
                Retry BSIMS
              </p>
            </router-link>
          </li>
          <li class="nav-item" v-if=can(menu.retrySetPermit)>
            <router-link :to="{name: 'RetrySetPermit'}" class="nav-link" active-class="active">
              <i class="fa fa-cog fa-lg"></i>&nbsp;
              <p>
                Retry Set Permit
              </p>
            </router-link>
          </li>
          <li class="nav-item" v-if=can(menu.mayday)>
            <router-link :to="{name: 'Mayday'}" class="nav-link" active-class="active">
              <i class="fa fa-cog fa-lg"></i>&nbsp;
              <p>
                MayDay
              </p>
            </router-link>
          </li>
          <li v-if=can(menu.schedules) class="nav-item">
            <router-link :to="{name: 'Schedules'}" class="nav-link" active-class="active">
              <i class="nav-icon fas fa-calendar"></i>
              <p>
                Schedule
              </p>
            </router-link>
          </li>
          <li v-if=can(menu.reports) class="nav-item">
            <router-link :to="{name: 'Reports'}" class="nav-link" active-class="active">
              <i class="nav-icon fas fa-book-open"></i>
              <p>
                Report
              </p>
            </router-link>
          </li>
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
export default {
  name: "SideBar",
  data: () => ({
    menu: {
      dashboard: 'superadmin|memberadmin|member|control_room|gate_pass',
      members:  'superadmin|gate_pass',
      users: 'superadmin|memberadmin',
      events: 'superadmin|control_room',
      bsims: 'superadmin|control_room',
      permits: 'superadmin|memberadmin|member|control_room',
      vehicles: 'superadmin|memberadmin|member|gate_pass',
      retry: 'superadmin',
      retrySetPermit: 'superadmin',
      mayday: 'superadmin',
      schedules: false, // true untuk all role
      reports: false,
    },
  }),
  computed: {
    user() {
      return this.$store.state.user.user;
    },
  }
}
</script>

<style scoped>

</style>
